const setAttributes = (el, attrs) => {
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in attrs) {
        el.setAttribute(key, attrs[key]);
    }
};

export default setAttributes;
